import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[markantPlatformScrollIndicator]',
})
export class ScrollIndicatorDirective implements AfterViewInit, OnDestroy {
  private scrollElement: HTMLElement;
  private observer: MutationObserver;

  /**
   * Test
   * @param el
   */
  constructor(private el: ElementRef) {
    this.scrollElement = this.el.nativeElement;
    this.observer = new MutationObserver(() => this.calculateScrollIndicator());
  }

  ngAfterViewInit(): void {
    this.calculateScrollIndicator();
    this.registerListenerForDomChanges();
  }

  ngOnDestroy(): void {
    this.observer.disconnect();
  }

  private calculateScrollIndicator(): void {
    if (!this.scrollElement.parentElement) {
      return;
    }

    const isScrollable = this.scrollElement.parentElement.offsetHeight < this.scrollElement.scrollHeight;

    this.updateScrollIndicatorStyles(isScrollable);

    this.scrollElement.addEventListener('scroll', () => {
      this.handleScroll();
    });
  }

  private updateScrollIndicatorStyles(isScrollable: boolean): void {
    if (isScrollable) {
      this.scrollElement.style.border = '0 solid rgba(191, 201, 209, 0.66)';
      this.scrollElement.style.borderBottomWidth = '2px';
      this.scrollElement.classList.add('scroll-indicator', 'top');
    } else {
      this.scrollElement.style.border = '';
      this.scrollElement.classList.remove('scroll-indicator', 'top');
    }
  }

  private handleScroll(): void {
    const isAtTop = this.scrollElement.scrollTop === 0;
    const isAtEnd =
      Math.round(this.scrollElement.scrollTop + this.scrollElement.offsetHeight) >=
      Math.round(this.scrollElement.scrollHeight);

    this.updateScrollPositionStyles(isAtTop, isAtEnd);
  }

  private updateScrollPositionStyles(isAtTop: boolean, isAtEnd: boolean): void {
    this.toggleTopIndicator(isAtTop);
    this.toggleEndIndicator(isAtEnd);
  }

  private toggleTopIndicator(isAtTop: boolean): void {
    if (isAtTop) {
      this.scrollElement.style.borderTopWidth = '0';
      this.scrollElement.classList.add('top');
    } else {
      this.scrollElement.style.borderTopWidth = '2px';
      this.scrollElement.classList.remove('top');
    }
  }

  private toggleEndIndicator(isAtEnd: boolean): void {
    if (isAtEnd) {
      this.scrollElement.style.borderBottomWidth = '0';
      this.scrollElement.classList.add('end');
    } else {
      this.scrollElement.style.borderBottomWidth = '2px';
      this.scrollElement.classList.remove('end');
    }
  }

  private registerListenerForDomChanges(): void {
    this.observer.observe(this.el.nativeElement, {
      attributes: false,
      childList: true,
      subtree: true,
    });
  }
}
